<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="afflictionForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :is-not-server-handled="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="affliction" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                afflictionForm: () => import('../forms/AfflictionForm'),
                affliction: () => import('../editViews/Affliction'),
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: 'Pest/Disease Type', value: 'afflictionType', format: this.formatEnum },
                    { text: 'Pest/Disease Rule', value: 'afflictionRule', format: this.formatRule },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                ],
                itemsField: 'afflictions',
                editPageName: 'affliction',
                apiMethod: 'Afflictions',
                claimName: 'Afflictions',
                formTitle: 'Pest/Disease',
                excelTitle: 'Afflictions',
                hasEditPage: true,
            }
        },
        methods: {
            formatRule(value) {
                return (value == "AmericanFoulbrood" ? "AFB" : value) + (value != "None" ? " (Notifiable)" : "")
            },
        }
    };
</script>
